export const ELEMENT_SCROLL_CONTENT_ID = "scroll-content";

export const SIZE_EXTRA_LARGE = 1700;
export const SIZE_LARGE = 1200;
export const SIZE_SMALL = 992;
export const SIZE_EXTRA_SMALL = 768;
